import { createElement } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import indexRoutes, { pageRoutes } from "./routes";
import SupportPage from "./presentation/pages/Support";
import { useMediaQuery, useTheme } from "@mui/material";

function App() {

    const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to={pageRoutes.Authenticate} />} />
          {indexRoutes.map((prop, key) => {
            return (
              <Route
                key={key}
                path={prop.path}
                element={createElement(prop.component)}
              >
                {prop.children?.map((prop, key) => {
                  return (
                    <Route
                      key={key}
                      path={prop.path}
                      element={createElement(prop.component)}
                    ></Route>
                  );
                })}
              </Route>
            );
          })}
        </Routes>
      </BrowserRouter>
     {/* 👇 Show SupportPage only on desktop */}
      {!isMobile && <SupportPage />}
    </>
  );
}

export default App;
